import { useCallback, useState } from 'react';

const useShowToggle = (defaultState = false) => {
  const [isShown, setIsShown] = useState(defaultState);
  const show = useCallback(() => setIsShown(true), []);
  const hide = useCallback(() => setIsShown(false), []);
  const toggle = useCallback(() => setIsShown((v) => !v), []);
  const update = useCallback((state: boolean) => setIsShown(state), []);
  return { isShown, show, hide, toggle, update };
};

export default useShowToggle;
